import React, { useEffect, useRef } from 'react';
import Button from 'lib/components/button.jsx';
import { Icon } from '@iconify-icon/react';
import { addClasses, cn } from '#lib/helpers/class.js';
import { useBool } from '#lib/hooks/use-boolean-state.js';

export function ResponsiveNav(props) {
    const { children, itemsCount } = props;
    const [isClicking, onMouseDown, onMouseUp] = useBool(false);
    const height = itemsCount * 40;
    const divRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                // If click is outside the div, execute the callback function
                onMouseUp();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onMouseUp]);

    return (
        <>
            <div className="hidden md:contents">{children}</div>
            <div
                className="md:hidden h-full flex items-center"
                onClick={() => (isClicking ? onMouseUp() : onMouseDown())}
                ref={divRef}
            >
                <div className="flex-shrink-0 text-neutral-600">
                    <div>
                        <Button as={Button} className="h-full" size="xs">
                            <Icon
                                icon="material-symbols:menu-rounded"
                                width="1.4rem"
                                height="1.4rem"
                                className={cn(
                                    'transition-all duration-500 text-primary-600',
                                    isClicking && '-rotate-90'
                                )}
                            />
                        </Button>
                        <div
                            className="fixed w-full left-0 top-[50px] z-10 flex flex-col gap-4 rounded-b-md bg-white shadow-lg transition-all duration-500 overflow-hidden delay-350"
                            style={{
                                height: isClicking ? `${height}px` : '0',
                                padding: isClicking ? '0.75rem 0.5rem' : '0 .5rem'
                            }}
                            onClick={() => (isClicking ? onMouseUp() : onMouseDown())}
                        >
                            {React.Children.map(children, (child, index) => {
                                if (!child) return null;
                                return (
                                    <Button
                                        as={child.type}
                                        {...child.props}
                                        key={index}
                                        onClick={() => (isClicking ? onMouseUp() : onMouseDown())}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
